var _style, _defs, _defs2, _defs3, _defs4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsotipo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000041271232358229685890000013756135913985465786_);fill:url(#SVGID_00000050641416687968958650000004566587587448323994_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000025413385423966217260000014001244119327987864_);fill:url(#SVGID_00000162326359228205194680000005290151873256529797_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000158725175557823482440000002985710445024613786_);fill:url(#SVGID_00000015312910771286240900000007613702847387167926_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000070827361797686616560000007535730656979302801_);fill:url(#SVGID_00000141437257699629847280000015859721387056035250_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M511.14,297.54c-19.44-1.74-38.58-3.47-55.7,7.4c-36.64,23.28-25.8,55.75-25.8,55.75 c40.76,2.38,106.49-28.31,106.49-28.31c-8.29,9.07-48.76,29.63-104.29,40.08c-13.27,1.99-24.31,1.54-30.24,1.01 c-2.62-0.23-4.93,1.67-5.22,4.29c-0.28,2.54,1.45,4.86,3.97,5.29c6.86,1.18,20.16,0.27,41.34-0.98 c26.1,19.35,68.91,14.8,94.46-2.13c46.59-30.87,41.61-96.47,41.61-96.47C557,301.6,533.87,299.56,511.14,297.54"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126314583410510613130000005734271732593956748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080901597023691085610000018090926711911820166_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 841.8718,
    x2: 1,
    y2: 841.8718,
    gradientTransform: "matrix(37.2821 94.9557 94.9557 -37.2821 -79468.75 31684.2715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1192,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    style: {
      stopColor: "#EE7941"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1847,
    style: {
      stopColor: "#D49559"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#B7A56E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    style: {
      stopColor: "#99AE7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    style: {
      stopColor: "#7AB28A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    style: {
      stopColor: "#5EB492"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5317,
    style: {
      stopColor: "#47B497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    style: {
      stopColor: "#3EB498"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EB498"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000126314583410510613130000005734271732593956748_)",
      fill: "url(#SVGID_00000080901597023691085610000018090926711911820166_)"
    },
    points: " 557.83,219.98 622.89,385.66 421.04,464.91 355.99,299.22  "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005266877183727135350000014678306141332302216_",
    width: 595.28,
    height: 841.89
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039129167451055611410000005763481610161286067_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005266877183727135350000014678306141332302216_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118360797901342828190000005774954722397100162_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 841.89,
    x2: 1,
    y2: 841.89,
    gradientTransform: "matrix(213.708 0 0 -213.708 212.534 180320.6562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1899,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1926,
    style: {
      stopColor: "#EE7941"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2966,
    style: {
      stopColor: "#D49559"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4034,
    style: {
      stopColor: "#B7A56E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5128,
    style: {
      stopColor: "#99AE7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6249,
    style: {
      stopColor: "#7AB28A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7406,
    style: {
      stopColor: "#5EB492"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#47B497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EB498"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000039129167451055611410000005763481610161286067_)",
      fill: "url(#SVGID_00000118360797901342828190000005774954722397100162_)"
    },
    points: " 307.48,547.76 307.48,557.76 212.93,557.76 324.25,246.3 425.84,246.3 314.53,557.76 307.48,557.76 307.48,547.76 298.07,544.39  397.46,266.3 338.34,266.3 241.32,537.76 307.48,537.76 307.48,547.76 298.07,544.39  "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000091010426717082102320000000276665629949281707_",
    d: "M46,552.9h80.36 c44.85-120.71,249.33-171.86,327.57-171.86c-19.15-4.45-54.97-9.69-98.08-9.69C250.59,371.35,101.85,402.6,46,552.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092444004418613827930000017326170867470577289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091010426717082102320000000276665629949281707_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061444342266324536710000007473721652921626298_",
    gradientUnits: "userSpaceOnUse",
    x1: -9.094947e-13,
    y1: 841.89,
    x2: 1,
    y2: 841.89,
    gradientTransform: "matrix(407.9256 0 0 -407.9256 46 343890.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0473,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505,
    style: {
      stopColor: "#EE7941"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1728,
    style: {
      stopColor: "#D49559"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2983,
    style: {
      stopColor: "#B7A56E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4271,
    style: {
      stopColor: "#99AE7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    style: {
      stopColor: "#7AB28A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    style: {
      stopColor: "#5EB492"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    style: {
      stopColor: "#47B497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EB498"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 371.35,
    style: {
      clipPath: "url(#SVGID_00000092444004418613827930000017326170867470577289_)",
      fill: "url(#SVGID_00000061444342266324536710000007473721652921626298_)"
    },
    width: 407.93,
    height: 181.55
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000153686301753515341190000017753672623837684915_",
    width: 595.28,
    height: 841.89
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106144423814916718920000004493687756250916793_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153686301753515341190000017753672623837684915_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022519490599431292740000018216883701256590750_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 841.89,
    x2: 1,
    y2: 841.89,
    gradientTransform: "matrix(213.707 0 0 -213.707 31.4081 180319.8281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1899,
    style: {
      stopColor: "#EF7840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1926,
    style: {
      stopColor: "#EE7941"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2966,
    style: {
      stopColor: "#D49559"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4034,
    style: {
      stopColor: "#B7A56E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5128,
    style: {
      stopColor: "#99AE7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6249,
    style: {
      stopColor: "#7AB28A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7406,
    style: {
      stopColor: "#5EB492"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#47B497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EB498"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000106144423814916718920000004493687756250916793_)",
      fill: "url(#SVGID_00000022519490599431292740000018216883701256590750_)"
    },
    points: " 126.36,547.76 126.36,557.76 31.81,557.76 143.12,246.3 244.72,246.3 133.4,557.76 126.36,557.76 126.36,547.76 116.94,544.39  216.33,266.3 157.21,266.3 60.19,537.76 126.36,537.76 126.36,547.76 116.94,544.39  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipo);
export default __webpack_public_path__ + "static/media/isotipo.120fb58f7d29ce4adc2933f9f03eaac8.svg";
export { ForwardRef as ReactComponent };